import type { EventParticipantRole } from 'models';
import { queryClient, useMutation } from 'query';
import { updateEventParticipant } from '../../services';
import { getEventParticipantsInfiniteQueryKey } from '../keys';

type UpdateEventParticipantVariables = {
  eventId: string;
  participantRef: string;
  role: EventParticipantRole;
};

export const useUpdateEventParticipant = () =>
  useMutation<unknown, UpdateEventParticipantVariables>({
    async mutationFn({ eventId, participantRef, role }) {
      const response = await updateEventParticipant({
        body: { role },
        routeParams: { eventId, participantId: participantRef },
      });

      return response.data;
    },
    async onSuccess(_, { eventId }) {
      await queryClient.invalidateQueries({ queryKey: getEventParticipantsInfiniteQueryKey({ filter: { eventId } }) });
    },
  });
